import { defaultDegreeImageRight } from "./types";
import { images } from "./static/images";

export const uncMbaDegreeImageRight: defaultDegreeImageRight = {
  aboutImage: {
    url: "https://images.cdn.edx.org/attachment-19551unc-about.jpg",
    altText: "UNC Kenan-Flagler MBA program",
    height: 800,
    width: 1200,
  },
  admissionsImage: {
    url: "https://images.cdn.edx.org/attachment-19552unc-admissions.jpg",
    altText: "UNC Kenan-Flagler MBA admissions",
    height: 800,
    width: 1200,
  },
  brandColor: "#4B9CD3",
};

export const ucbMidsDegreeImageRight: defaultDegreeImageRight = {
  aboutImage: {
    url: "https://images.cdn.edx.org/attachment-19549ucb-about.jpg",
    altText: "UC Berkeley MIDS program",
    height: 440,
    width: 1200,
  },
  admissionsImage: {
    url: "https://images.cdn.edx.org/attachment-19550ucb-admissions.jpg",
    altText: "UC Berkeley MIDS admissions",
    height: 801,
    width: 1200,
  },
  brandColor: "#002676",
};

export const ucbCybersecurityDegreeImageRight: defaultDegreeImageRight = {
  aboutImage: {
    url: "https://images.cdn.edx.org/attachment-19549ucb-about.jpg",
    altText: "UC Berkeley Cybersecurity program",
    height: 440,
    width: 1200,
  },
  admissionsImage: {
    url: "https://images.cdn.edx.org/attachment-19550ucb-admissions.jpg",
    altText: "UC Berkeley Cybersecurity admissions",
    height: 801,
    width: 1200,
  },
  brandColor: "#002676",
};

export const nyuMentalHealthDegreeImageRight: defaultDegreeImageRight = {
  aboutImage: {
    url: "https://images.cdn.edx.org/attachment-19547nyu-about.jpg",
    altText: "NYU Steinhardt Mental Health Counseling program",
    height: 800,
    width: 1200,
  },
  admissionsImage: {
    url: "https://images.cdn.edx.org/attachment-19548nyu-admissions.jpg",
    altText: "NYU Steinhardt Mental Health Counseling admissions",
    height: 801,
    width: 1200,
  },
  brandColor: "#57068C",
};

export const maryvilleDegreeImageRight: defaultDegreeImageRight = {
  aboutImage: {
    url: "https://images.cdn.edx.org/attachment-19545mvu-about.jpg",
    altText: "Maryville University program",
    height: 671,
    width: 1200,
  },
  admissionsImage: {
    url: "https://images.cdn.edx.org/attachment-19546mvu-admissions.jpg",
    altText: "Maryville University admissions",
    height: 559,
    width: 1200,
  },
  brandColor: "#C91235",
};

export const staticImages: Record<string, defaultDegreeImageRight> = {
  "398d8e39-3276-4ad0-a912-f565f4857b59": {
    aboutImage: images["ALB-UMT_Campus_2023-05_CSI_001"],
    admissionsImage: images["ALB-UMT_Immersion_2023-08_CSI_002"],
    brandColor: "#862633",
  },
  "b31e368f-e2e9-40dc-ac24-d3a716416f94": {
    aboutImage: images["ALB-UMT_Campus_2023-05_CSI_001"],
    admissionsImage: images["ALB-UMT_Immersion_2023-08_CSI_002"],
    brandColor: "#862633",
  },
  "fe201bf7-b2eb-4564-b533-adeb7d504ff8": {
    aboutImage: images["AU-IR_Campus_2019-08_EKinsolving_017"],
    admissionsImage: images["AU-MIR_175138289_GettyImages"],
    brandColor: "#004FA2",
  },
  "c6d974eb-34b9-4293-97ac-a16bff173637": {
    aboutImage: images["AU-LAW_Campus_2016-07_CSI_002"],
    admissionsImage: images["AU-LAW_Campus_2019-09_EKinsolving_006"],
    brandColor: "#004FA2",
  },
  "fdbe8629-5b86-4833-b470-edcddec839f1": {
    aboutImage: images["AU-IR_Campus_2019-08_EKinsolving_017"],
    admissionsImage: images["AU-MIR_175138289_GettyImages"],
    brandColor: "#004FA2",
  },
  "a97f4eb0-2286-4417-84c7-500b3f01a393": {
    aboutImage: images["EC-MSL_Campus_2019-05_EKinsolving_029"],
    admissionsImage:
      images["EC-MSL_People-With-Technology_2017-11_DPalmer_009"],
    brandColor: "#62259D",
  },
  "1317c738-e38b-4520-abf4-c5f5e8ca22c2": {
    aboutImage: images["FOR-LAW_Campus_2012-10_CShinn_002"],
    admissionsImage: images["FOR-MSW_Campus_2016-04_CSI_022"],
    brandColor: "#7e072a",
  },
  "a2176c91-d3b8-47f2-8ded-f5587026f396": {
    aboutImage: images["GU-MSN_Campus_2019-04_Flickr_5634335599"],
    admissionsImage: images["GU-MSN_Campus_2011-07_Flickr_5937268210"],
    brandColor: "#033C5A",
  },
  "f584d7b2-8e9e-4118-88a8-42c3c34b4333": {
    aboutImage: images["GU-MSN_Campus_2019-04_Flickr_5634335599"],
    admissionsImage: images["GU-MSN_Campus_2011-07_Flickr_5937268210"],
    brandColor: "#033C5A",
  },
  "46231e86-e3e5-4e23-8095-0c8694de58f2": {
    aboutImage: images["GU-MSN_Campus_2019-04_Flickr_5634335599"],
    admissionsImage: images["GU-MSN_Campus_2011-07_Flickr_5937268210"],
    brandColor: "#033C5A",
  },
  "d0efa09a-7b03-4c1e-b860-30baa53a8d3b": {
    aboutImage: images["HPU-UMT_Campus_2024-2_School Provided_A7307309_SM"],
    admissionsImage: images["HPU-UMT_Campus_2024-2_School Provided_IMG_0598"],
    brandColor: "#007298",
  },
  "21a7e677-0e8d-4d4a-a2e1-83b9caaa2e64": {
    aboutImage: images["HPU-UMT_Campus_2024-2_School Provided_A7307309_SM"],
    admissionsImage: images["HPU-UMT_Campus_2024-2_School Provided_IMG_0598"],
    brandColor: "#007298",
  },
  "8baf10dd-2d27-4124-8821-ffecc92e9e4b": {
    aboutImage: images["HPU-UMT_Campus_2024-2_School Provided_IMG_0598"],
    admissionsImage: images["HPU-UMT_Campus_2024-2_School Provided_IMG_0598"],
    brandColor: "#007298",
  },
  "a7cd9cdb-4a8c-4da5-af2b-f072fde3b21a": {
    aboutImage: images["HPU-UMT_Campus_2024-2_School Provided_A7307309_SM"],
    admissionsImage: images["HPU-UMT_Campus_2024-2_School Provided_IMG_0598"],
    brandColor: "#007298",
  },
  "fdc2f05f-3ae3-4a5b-8a75-118a7554e251": {
    aboutImage: images["HOW-MSW_Campus_2020-11_CSI_001_edit"],
    admissionsImage: images["HOW-MSW_Zoom_StudentGrid-12_OTS-Laptop"],
    brandColor: "#007298",
  },
  "b794082c-ab8d-40ae-8e22-470b2a937d01": {
    aboutImage:
      images[
        "LU-UMT_Campus_2025-1_School Provided_SL_LancsUni_Jun22_SLV_2944_HR"
      ],
    admissionsImage:
      images["LU-UMT_People with Tech_2025-1_School Provided_2624_0618"],
    brandColor: "#B5121B",
  },
  "f968c923-2db3-4d29-8c0b-bbb0236f10bd": {
    aboutImage:
      images[
        "LU-UMT_Campus_2025-1_School Provided_SL_LancsUni_Jun22_SLV_2944_HR"
      ],
    admissionsImage:
      images["LU-UMT_People with Tech_2025-1_School Provided_2624_0618"],
    brandColor: "#B5121B",
  },
  "08b71870-dd3a-48aa-9ba5-ec82328219d1": {
    aboutImage:
      images[
        "LU-UMT_Campus_2025-1_School Provided_SL_LancsUni_Jun22_SLV_2944_HR"
      ],
    admissionsImage:
      images["LU-UMT_People with Tech_2025-1_School Provided_2624_0618"],
    brandColor: "#B5121B",
  },
  "80c8b1b4-de3a-4914-ab4a-5cdab21ec68d": {
    aboutImage:
      images[
        "LU-UMT_Campus_2025-1_School Provided_SL_LancsUni_Jun22_SLV_2944_HR"
      ],
    admissionsImage:
      images["LU-UMT_People with Tech_2025-1_School Provided_2624_0618"],
    brandColor: "#B5121B",
  },
  "96400e4a-52cb-42c2-b974-bad2cb08d8f0": {
    aboutImage:
      images[
        "LU-UMT_Campus_2025-1_School Provided_SL_LancsUni_Jun22_SLV_2944_HR"
      ],
    admissionsImage:
      images["LU-UMT_People with Tech_2025-1_School Provided_2624_0618"],
    brandColor: "#B5121B",
  },
  "5e15f5aa-8a0a-4362-833d-1c9875e1ebad": {
    aboutImage: images["LSE-DIT_894314988"],
    admissionsImage: images["LSE_05"],
    brandColor: "#E63635",
  },
  "8667372e-53eb-44a9-9dd0-c494e72d7db1": {
    aboutImage: images["LSE-DIT_894314988"],
    admissionsImage: images["LSE_05"],
    brandColor: "#E63635",
  },
  "f9414209-c0ac-4572-bb46-2dde155f3a22": {
    aboutImage: images["LSE-DIT_894314988"],
    admissionsImage: images["LSE_05"],
    brandColor: "#E63635",
  },
  "2fca092d-dfdf-4389-a68f-6023618f63db": {
    aboutImage: images["LSE-DIT_894314988"],
    admissionsImage: images["LSE_05"],
    brandColor: "#E63635",
  },
  "123f9327-bfef-459f-8bf2-c53277aa58f8": {
    aboutImage: images["LSE-DIT_894314988"],
    admissionsImage: images["LSE_05"],
    brandColor: "#E63635",
  },
  "183bd207-c328-45f7-a80c-959fd358ea78": {
    aboutImage: images["LSE-DIT_894314988"],
    admissionsImage: images["LSE_05"],
    brandColor: "#E63635",
  },
  "402fd109-5b4c-4f9e-8b2a-c6e5ac26bfe5": {
    aboutImage: images["MC-UG_Campus_2019-04_Raftermen_002"],
    admissionsImage: images["MC-UG_Zoom_StudentGrid-12_Mockup-OTS-Desktop"],
    brandColor: "#0044c7",
  },
  "2b7cf950-f3d6-4b6b-8ef0-8e6349fb5e25": {
    aboutImage:
      images["MGH-MHA_Campus_2024-8_School Provided_1317_25859441656_o"],
    admissionsImage:
      images["MGH-MHA_Student_2024-8_School Provided_20220620-1069"],
    brandColor: "#840028",
  },
  "58617e13-78f5-42db-8634-ced77963c170": {
    aboutImage: images["NYU-MSL_Campus_2019-06_EKinsolving_003"],
    admissionsImage: images["NYU-MAC_Zoom_Mockup-OTS_StudentGrid-12"],
    brandColor: "#57068c",
  },
  "40f35071-3472-4fe8-ae95-1ab1b91ea9e2": {
    aboutImage: images["NU_KELLOG_02"],
    admissionsImage: images["NU-MAC_Zoom_StudentGrid-12_Mockup-OTS-V1"],
    brandColor: "#4E2A84",
  },
  "6554a6fc-8181-43b4-a33f-5b2764a4957f": {
    aboutImage: images["NU_KELLOG_02"],
    admissionsImage: images["NU-MAC_Zoom_StudentGrid-12_Mockup-OTS-V1"],
    brandColor: "#4E2A84",
  },
  "85f981c8-4e1b-4cc4-b3cc-cd2bd741b405": {
    aboutImage: images["PEP-PSY_6U2A9608_Kinsolving_Campus_7-2019"],
    admissionsImage: images["PEP-PSY_MKTGAD-5949_Zoom_LaptopMockup"],
    brandColor: "#00205c",
  },
  "a8017a12-63e9-48b5-b09c-535f495b1c01": {
    aboutImage: images["PEP-LAW_Campus_2015-10_CSI_002"],
    admissionsImage: images["PEP-PSY_MKTGAD-5949_Zoom_LaptopMockup"],
    brandColor: "#00205c",
  },
  "b201cbf8-8b05-4f3b-8825-f3ddddf6020a": {
    aboutImage: images["PEP-PSY_6U2A9608_Kinsolving_Campus_7-2019"],
    admissionsImage: images["PEP-PSY_MKTGAD-5949_Zoom_LaptopMockup"],
    brandColor: "#00205c",
  },
  "1fd36b6e-0b71-4c10-9d81-1bfaab141b10": {
    aboutImage: images["PEP-LAW_Campus_2015-10_CSI_002"],
    admissionsImage: images["PEP-PSY_MKTGAD-5949_Zoom_LaptopMockup"],
    brandColor: "#00205c",
  },
  "b944d61a-e4d3-433a-bfff-72efa89264ee": {
    aboutImage: images["PEP-PSY_6U2A9608_Kinsolving_Campus_7-2019"],
    admissionsImage: images["PEP-PSY_MKTGAD-5949_Zoom_LaptopMockup"],
    brandColor: "#00205c",
  },
  "6f1ed8e7-af2e-4eea-a2af-f259ec749ffe": {
    aboutImage: images["PEP-PSY_6U2A9608_Kinsolving_Campus_7-2019"],
    admissionsImage: images["PEP-PSY_MKTGAD-5949_Zoom_LaptopMockup"],
    brandColor: "#00205c",
  },
  "a3a4ba76-f2b1-4e7e-a008-b4ba817f9466": {
    aboutImage:
      images["PEP-MSLP_Campus_2024-9_School Provied_226084_DJI_0034a"],
    admissionsImage: images["PEP-PSY_MKTGAD-5949_Zoom_LaptopMockup"],
    brandColor: "#00205c",
  },
  "fbec17ab-a5db-4b44-b81a-a2ff30b3b9e3": {
    aboutImage:
      images["PEP-MSLP_Campus_2024-9_School Provied_226084_DJI_0034a"],
    admissionsImage: images["PEP-PSY_MKTGAD-5949_Zoom_LaptopMockup"],
    brandColor: "#00205c",
  },
  "3001f267-a52b-4513-9d5c-bce423e05eb6": {
    aboutImage: images["RICE-MBA_Campus_2017-02_JFitlow_006"],
    admissionsImage: images["RICE-MBA_People-with-Technology_2020-03_ATao_008"],
    brandColor: "#00205B",
  },
  "30ce6383-910f-4e6e-aaba-5092401f60f2": {
    aboutImage: images["RIT-ARC_Campus_2020-08_CSI_003"],
    admissionsImage:
      images["RIT-ARC_People-with-Technology_2019-08_AdobeStock_294392902"],
    brandColor: "#F76902",
  },
  "b1e90965-b4a0-4ae8-850f-29ee8872eafc": {
    aboutImage: images["RSC-MSOT_Campus_2023-09_THansen_001"],
    admissionsImage:
      images["RSC-MSOT_People on the Job_2024-5_GettyImages_2094339326"],
    brandColor: "#309b42",
  },
  "0890de3f-7556-4089-ae2d-7a945f6f6a7d": {
    aboutImage: images["SC-MSN_Campus_2013-01_JGillooly_0019-EDIT"],
    admissionsImage:
      images["SC-MSN_People-with-Technology_2014-03_JDavis_1013"],
    brandColor: "#003A70",
  },
  "71cbb501-78b9-4e1c-870e-9db8f92d4b1d": {
    aboutImage: images["070817CC128"],
    admissionsImage: images["SC-MSW_008_PeopleTechnology_2015"],
    brandColor: "#003A70",
  },
  "7d5dabaa-44c0-4c12-a47e-b74a633a0e03": {
    aboutImage: images["SC-ENT_6U2A3005_Kinsolving_Campus_7-2019"],
    admissionsImage: images["SC-ABA_Zoom_9-Class_Over-the-Shoulder_12-2018"],
    brandColor: "#003A70",
  },
  "fdcd0ca4-34b9-4373-9a5f-a357d13156be": {
    aboutImage: images["SJF-MSN_06_CSI_Nursing-Building_10-2020"],
    admissionsImage: images["SJF-MSN_Zoom_OTS-V2_StudentGrid-25"],
    brandColor: "#993333",
  },
  "9a6bc27b-2d27-4064-801b-951960ba661d": {
    aboutImage: images["SMU-MDS_Campus_2006-08_CSI_001"],
    admissionsImage:
      images["SMU-MDS_People-with-Technology_2014-02_YArcurs_001"],
    brandColor: "#354CA1",
  },
  "621197db-204b-4a90-b2cd-44446f7d55b4": {
    aboutImage: images["SYR-UMT_001_CSI_Campus_2021-08."],
    admissionsImage: images["PEP-PSY_MKTGAD-5949_Zoom_LaptopMockup"],
    brandColor: "#F76900",
  },
  "ea953e86-de57-4512-8503-a89f00f1b2b1": {
    aboutImage: images["SYR-UMT_001_CSI_Campus_2021-08."],
    admissionsImage: images["SYR-MSW_Zoom_OverTheShoulder_StudentGrid12"],
    brandColor: "#F76900",
  },
  "780e11a3-0b47-424f-8a03-3f0a9072c5ec": {
    aboutImage: images["SYR-UMT_001_CSI_Campus_2021-08."],
    admissionsImage: images["SYR-MSW_Zoom_OverTheShoulder_StudentGrid12"],
    brandColor: "#F76900",
  },
  "6b8dd314-fcd1-45ab-bbda-2f9e8c7c113e": {
    aboutImage: images["SYR-UMT_001_CSI_Campus_2021-08."],
    admissionsImage: images["SYR-MSW_Zoom_OverTheShoulder_StudentGrid12"],
    brandColor: "#F76900",
  },
  "0a981ea4-4f5e-4a31-aadd-4f1394072279": {
    aboutImage: images["SYR-UMT_001_CSI_Campus_2021-08."],
    admissionsImage: images["SYR-MSW_Zoom_OverTheShoulder_StudentGrid12"],
    brandColor: "#F76900",
  },
  "5cf16e5f-8a08-40a6-bc9e-bf82684c5522": {
    aboutImage: images["SYR-UMT_001_CSI_Campus_2021-08."],
    admissionsImage: images["SYR-MSW_Zoom_OverTheShoulder_StudentGrid12"],
    brandColor: "#F76900",
  },
  "f5c98fd9-a2f9-40a1-870a-23fbbe4657a3": {
    aboutImage: images["SYR-UMT_001_CSI_Campus_2021-08."],
    admissionsImage: images["SYR-MSW_Zoom_OverTheShoulder_StudentGrid12"],
    brandColor: "#F76900",
  },
  "7e610677-ff84-40c0-8f24-657173f95b48": {
    aboutImage: images["SYD-UMT_Campus_2017-01_LCooper_019"],
    admissionsImage:
      images["SYD-UMT_People on the Job_2023-7_GettyImages_1440556661"],
    brandColor: "#e64626",
  },
  "fcdd8ed0-e925-4961-a6d8-80b961bc32e4": {
    aboutImage: images["SYD-UMT_Campus_2017-01_LCooper_019"],
    admissionsImage:
      images["SYD-UMT_People on the Job_2023-7_GettyImages_1440556661"],
    brandColor: "#e64626",
  },
  "0a8e551b-50fc-4ce3-988c-eee23c7bbcd0": {
    aboutImage: images["SYD-UMT_Campus_2017-01_LCooper_019"],
    admissionsImage:
      images["SYD-UMT_People on the Job_2023-7_GettyImages_1440556661"],
    brandColor: "#e64626",
  },
  "0efb8c66-6727-4b44-a948-e947dc1355a7": {
    aboutImage: images["SYD-UMT_Campus_2017-01_LCooper_019"],
    admissionsImage:
      images["SYD-UMT_People on the Job_2023-7_GettyImages_1440556661"],
    brandColor: "#e64626",
  },
  "4a5f20a5-0306-4c5a-89b6-f3013d8ce2f4": {
    aboutImage: images["UTA-UMT_Campus_2017-11_CSI_001"],
    admissionsImage:
      images["UTA-MAI-BC_People on the Job_2024-5_GettyImages_1415142004"],
    brandColor: "#bf5700",
  },
  "854a7267-22ae-4341-9f14-3e8f554395bb": {
    aboutImage:
      images[
        "UWM-MSB_Campus_Grainger Hall_Exterior_2023-1_School Provided_0714_043"
      ],
    admissionsImage:
      images[
        "UWM-MSB_Campus_Grainger Hall_Exterior_2023-1_School Provided_0714_043"
      ],
    brandColor: "#C5050C",
  },
  "74f633a8-2eaa-4202-9e31-79f6868934b0": {
    aboutImage:
      images[
        "UCD-MM_Campus_welcome-center_2023-8_School Provided_20130808-158"
      ],
    admissionsImage: images["UCD-MM_Students_2023-8_Zoom_Mockup_v2"],
    brandColor: "#228510",
  },
  "fe32d1c5-5e22-4f5a-8a92-71ef3d654d96": {
    aboutImage:
      images[
        "UCD-MM_Campus_welcome-center_2023-8_School Provided_20130808-158"
      ],
    admissionsImage: images["UCD-MM_Students_2023-8_Zoom_Mockup_v2"],
    brandColor: "#228510",
  },
  "8f98a6c0-c6c2-4571-9965-2b3586ae9a8c": {
    aboutImage: images["MIA-MBA_Campus_2022-7_School Provided_Drone 0142"],
    admissionsImage:
      images["MIA-MBA_People-with-Technology_2020-02_CLawrie_001"],
    brandColor: "#F47321",
  },
  "70adbe06-2ef5-446e-97cf-7d26520a9697": {
    aboutImage: images["UNC_KF_04"],
    admissionsImage: images["UNC-MPH_887_Kinsolving_Group_7-2019"],
    brandColor: "#4B9CD3",
  },
  "4a8c1f85-f7bb-4ba9-b102-b5864c921fa1": {
    aboutImage: images["UNC_KF_04"],
    admissionsImage:
      images["UNC-UMT_People-with-Technology_2023-10_Getty_1271562709"],
    brandColor: "#4B9CD3",
  },
  "e063e130-dd2b-444a-820a-29a963259796": {
    aboutImage: images["DAY_02"],
    admissionsImage: images["UD-EDU_On the Job_2022-3_GettyImages_1034426836"],
    brandColor: "#002554",
  },
  "273b170f-af05-4036-9f51-d865910959e2": {
    aboutImage: images["DEN-MSW_Campus_2011-10_WArmstrong_001"],
    admissionsImage:
      images["UD-EDU_People-with-Technology_2018-01_Getty_1248900587.jpg"],
    brandColor: "#BA0C2F",
  },
  "8c821199-2c80-4c82-9539-4ef685f2c5e7": {
    aboutImage: images["DEN-MSW_Campus_2011-10_WArmstrong_001"],
    admissionsImage:
      images["UD-EDU_People-with-Technology_2018-01_Getty_1248900587.jpg"],
    brandColor: "#BA0C2F",
  },
  "9bdd0a1d-fcfb-43b3-a2c1-73a9c966cc01": {
    aboutImage: images["DEN-MSW_Campus_2011-10_WArmstrong_001"],
    admissionsImage:
      images["UD-EDU_People-with-Technology_2018-01_Getty_1248900587.jpg"],
    brandColor: "#BA0C2F",
  },
  "c106927f-09cc-4b9a-9f8c-c757db45d92a": {
    aboutImage: images["UL-BDS_Campus_CSI_2021-10_025"],
    admissionsImage:
      images["UL-BDS_People-with-Technology_2019-03_Getty_1186931714"],
    brandColor: "#e63635",
  },
};
